/* eslint-disable */ import { memoEval, replaceEntityRecipesComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const cornerBoltHolesComponents = [
    attachComponent.withComponent(replaceEntityRecipesComponent, 'default', true).withEntity('CornerBoltHoles').attach(memoEval((self)=>[
            self.$cornerCountersinkHolesRecipes
        ], ($cornerCountersinkHolesRecipes)=>({
            recipes: $cornerCountersinkHolesRecipes,
            keepChildren: true
        })))
];

//# sourceMappingURL=corner-bolt-holes.js.map